import { messages as en } from './en/messages';
import { messages as fr } from './fr/messages';

export const catalogs = { en, fr };
